import { render, staticRenderFns } from "./POSStoreCustomer.vue?vue&type=template&id=0c6bf432&scoped=true&"
import script from "./POSStoreCustomer.vue?vue&type=script&lang=ts&"
export * from "./POSStoreCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./POSStoreCustomer.vue?vue&type=style&index=0&id=0c6bf432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6bf432",
  null
  
)

export default component.exports